export default __webpack_public_path__ + "static/media/ajax_spinner.4f00b316.gif";